import { render, staticRenderFns } from "./ResultTop.vue?vue&type=template&id=4cbd6e54&scoped=true&"
import script from "./ResultTop.vue?vue&type=script&lang=ts&"
export * from "./ResultTop.vue?vue&type=script&lang=ts&"
import style0 from "./ResultTop.vue?vue&type=style&index=0&id=4cbd6e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd6e54",
  null
  
)

export default component.exports